import { styled } from '@mui/material/styles';
export const Image = styled('img')(({
  width = 22,
  height = 22
}) => ({
  width,
  height,
  objectFit: 'cover',
  borderRadius: '50%',
  border: '1px solid #FFF'
}));